import { compose } from '@axilon-apps/libs-shared-utils'

import calculatePasswordFeedback from './calculate-password-feedback'
import calculatePasswordStrength from './calculate-password-strength'

const calculatePasswordComplexity = compose(calculatePasswordFeedback, calculatePasswordStrength)

export default calculatePasswordComplexity
